import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Foundation from "@/pages/Foundation";

export const Route = createFileRoute("/en/about-qbd/qbd-group-foundation")({
  head: () => buildRouteHead("/en/about-qbd/qbd-group-foundation"),
  component: Foundation,
});

